import { defineStore } from "pinia";
import { computed, ref } from "vue";

export type RegistrationCodeStatus = "idle" | "validating" | "valid" | "invalid" | "expired";

export const useRegisterStore = defineStore("register", () => {
  const language = ref<string>("en");

  const name = ref<string>("");
  const email = ref<string>("");
  const phoneNumber = ref<string>("");
  const shopUrl = ref<string>("");

  const hasRegistrationCode = ref<boolean>(false);
  const registrationCode = ref<string>("");
  const registrationCodeStatus = ref<RegistrationCodeStatus>("idle");

  const formValidationErrors = ref({
    isValidating: false,
    name: "",
    email: "",
    phoneNumber: "",
    shopUrl: "",
    captcha: "",
  });

  const formValidationErrorsBackend = ref({
    email: "",
    shopUrl: "",
    captcha: "",
  });

  const isFormValid = computed(
    () =>
      !formValidationErrors.value.name &&
      !formValidationErrors.value.email &&
      !formValidationErrors.value.phoneNumber &&
      !formValidationErrors.value.shopUrl &&
      !formValidationErrorsBackend.value.email &&
      !formValidationErrorsBackend.value.shopUrl
  );

  return {
    language,
    name,
    email,
    phoneNumber,
    shopUrl,
    hasRegistrationCode,
    registrationCode,
    registrationCodeStatus,
    formValidationErrors,
    formValidationErrorsBackend,
    isFormValid,
  };
});
